module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Chicken-26853390788e48d83390dabe7bf5c048.svg";